import { i as A, e as x, b as z, x as c, T as E, a as k, n as l, r as f } from "./abstract-base-CzLmw6_x.js";
import { e as w } from "./query-DolxHPXs.js";
import { e as g } from "./class-map-DVI1Gii9.js";
import { o as _ } from "./unsafe-svg-LX0N8ZFI.js";
import { B as L } from "./table-cell-DSuHhZzg.js";
import { C as O } from "./cta-variant-SwPVCQO_.js";
import { S as P } from "./scale--i04D-nH.js";
import { a as $, c as B } from "./chevron-up-BdCh5zxY.js";
import { B as M } from "./beacon-primitive-ChVMWFlW.js";
import { p as C, d as V } from "./lifecycle-decorators-CUsT9aHq.js";
import { b } from "./query-assigned-K46zQIzj.js";
var r = /* @__PURE__ */ ((d) => (d.ONE = "1", d.TWO = "2", d.THREE = "3", d))(r || {});
const q = A`[beacon-tag-name=beacon-table-stub] [slot=title-icon]{--title-icon-margin-block-start: var(--beacon-table-stub-title-icon-space-margin-block-start-normal);margin-block-start:var(--title-icon-margin-block-start);margin-inline-start:var(--beacon-unit-subatomic)}[beacon-tag-name=beacon-table-stub] [slot=category-icon]{margin-block:var(--beacon-table-stub-category-icon-space-margin-block)}[beacon-tag-name=beacon-table-stub] [slot=category-icon],[beacon-tag-name=beacon-table-stub] [slot=title-icon]{block-size:var(--beacon-unit-base);inline-size:var(--beacon-unit-base)}[beacon-tag-name=beacon-table-stub] [slot=action-zone-right]{margin:var(--table-override-stub-action-zone-right-space, var(--beacon-unit-atomic))}[beacon-tag-name=beacon-table-stub] [slot=action-zone-left]{margin-block-start:var(--action-zone-left-margin-block-start)}[beacon-tag-name=beacon-table-stub] [slot=value-prop]{grid-area:value-prop;margin-inline-end:var(--value-prop-margin-inline-end);padding:calc(.125 * var(--beacon-unit-base))}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-bold-100) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-stub][level="2"] .beacon-table-stub__title,[beacon-tag-name=beacon-table-stub][level="3"] .beacon-table-stub__title{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-footnote{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon{align-self:center;margin-inline-start:var(--beacon-unit-subatomic)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__title-icon,[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{block-size:var(--beacon-unit-base);inline-size:var(--beacon-unit-base)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category{--category-text-margin-block-start: calc(.125 * var(--beacon-unit-base));font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-bold-200) var(--beacon-font-family-default));margin-block-start:var(--category-text-margin-block-start)}[beacon-tag-name=beacon-table-stub] .beacon-table-stub__category-icon{margin-block:var(--beacon-table-stub-category-icon-space-margin-block)}`, G = A`@charset "UTF-8";:host{--override-button-space-padding-tertiary: calc(.75 * var(--beacon-unit-base));--override-button-font-size-mini: var(--beacon-caption-font-size-200);--override-button-font-line-height-mini: var(--beacon-caption-font-line-height-module-200);--override-button-color-text-tertiary-default: var(--beacon-color-cta-text-tertiary-default-on-light);--override-button-icon-space-margin: var(--beacon-unit-subatomic);--content-grid-template: "value-prop" "standard";--value-prop-margin-inline-end: 0;--action-zone-left-margin-block-start: var(--beacon-unit-atomic);--stub-content-margin-inline-start: var(--beacon-table-stub-space-margin-inline-start);--stub-content-margin-inline-end: var(--beacon-table-stub-space-margin-inline-end);color:var(--beacon-color-text-default-on-light);inline-size:inherit;word-break:initial}:host([value-prop-left]){--content-grid-template: "value-prop standard";--value-prop-margin-inline-end: var(--beacon-unit-subatomic)}p{margin:0}.title{display:flex;grid-area:title}.title-footnote,::slotted(sup){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default))}.title-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-bold-100) var(--beacon-font-family-default))}.category{align-items:center;display:flex;grid-area:category}.standard{display:grid;grid-template-areas:"category" "title" "attributes" "status" "description" "footnote"}.title,.category{font-weight:var(--beacon-font-weight-bold)}.content{display:grid;flex-grow:1;grid-template-areas:var(--content-grid-template)}.content .standard .title{margin-block-start:var(--beacon-unit-subatomic)}.content .standard>*,.content .standard .category+.title{margin-block-start:calc(.125 * var(--beacon-unit-base))}.content .standard .status{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default));background-color:var(--beacon-color-border-secondary);border-radius:calc(.125 * var(--beacon-unit-base));grid-area:status;inline-size:fit-content;margin-block-start:var(--beacon-unit-atomic);padding-block:calc(.125 * var(--beacon-unit-base));padding-inline:calc(.375 * var(--beacon-unit-base))}.content .standard .status+*{margin-block-start:var(--beacon-unit-atomic)}.content .hide{display:none}.content-wrapper{display:flex}.stub{display:grid;margin-inline-end:var(--stub-content-margin-inline-end);margin-inline-start:var(--stub-content-margin-inline-start)}.stub.level-2 .title-text,.stub.level-3 .title-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.stub.level-2 ::slotted([slot=title-icon]),.stub.level-3 ::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--beacon-table-stub-title-icon-space-margin-block-start-mini)}.stub.level-2 .content,.stub.level-3 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-unit-base))}.stub.level-3 .title-text{font-weight:var(--beacon-font-weight-normal)}.dropdown{display:var(--table-override-stub-dropdown-display, initial);justify-self:end}.attributes{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));grid-area:attributes}.category-text{--category-text-margin-block-start: calc(.125 * var(--beacon-unit-base));font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-bold-200) var(--beacon-font-family-default));margin-block-start:var(--category-text-margin-block-start)}.description{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));grid-area:description;margin-block-start:var(--beacon-unit-atomic)}.footnote{font-size:var(--beacon-caption-font-size-200);grid-area:footnote;line-height:var(--beacon-caption-font-line-height-module-200)}@media (prefers-reduced-motion){.floating-stub{display:none}}@media (prefers-reduced-motion: no-preference){.floating-stub{background:var(--beacon-color-border-secondary);display:grid;grid-template-areas:"category title";inline-size:max-content;inset-block-start:0;inset-inline-start:var(--table-stub-floating-override-inset-inline-start, 0);margin-block-start:calc(-1 * var(--beacon-table-base-stub-space-padding-block));margin-inline-start:var(--table-stub-floating-override-margin-inline-start, -500%);padding-block-start:calc(.125 * var(--beacon-unit-base));padding-inline:var(--beacon-table-stub-floating-space-padding-inline);place-items:center;position:absolute;transform:translateY(-50%);transition:margin-inline-start 1s;z-index:2}.floating-stub .category:after{content:"·";margin-inline:var(--beacon-table-stub-category-space-margin-inline)}.floating-stub .category-text{margin:0}.floating-stub .title,.floating-stub .category .category-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-bold-200) var(--beacon-font-family-default))}.floating-stub .category-icon{margin-block:var(--beacon-table-stub-category-icon-space-margin-block)}}.wrapper{position:relative}@media (width >= 1280px){.category-text{--category-text-margin-block-start: 0}}`;
var F = Object.defineProperty, H = Object.getOwnPropertyDescriptor, a = (d, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? H(t, e) : t, s = d.length - 1, p; s >= 0; s--)
    (p = d[s]) && (i = (n ? p(t, e, i) : p(i)) || i);
  return n && i && F(t, e, i), i;
};
const h = "beacon-table-stub", K = ["beacon-button"], W = "·", T = "1px solid var(--beacon-color-border-secondary)", v = "0", Y = "calc(var(--beacon-unit-atomic) + var(--beacon-table-row-space-padding))", u = "th", Z = "tr", m = "border-block-end", U = "beacon-table", R = "display", X = "none", j = "padding-block-end", Q = "--inset-divider-border", J = "--inset-divider-padding-block-start", tt = "table-row", D = "--inset-divider-margin-start", et = "calc(var(--beacon-unit-atomic) + var(--beacon-unit-base) + var(--beacon-table-stub-space-margin-inline-start))", ot = "calc(var(--beacon-unit-atomic) + var(--beacon-unit-base) + var(--beacon-table-stub-space-margin-inline-start))", N = "--inset-divider-margin-end", at = "13px", I = "BEACON-CHECKBOX", nt = "--action-zone-left-margin-block-start", it = "checkbox", st = 'input[type="checkbox"]', rt = "calc(var(--beacon-unit-atomic) + var(--beacon-table-stub-space-margin-inline-start))", lt = "calc(var(--beacon-unit-atomic) + var(--beacon-table-stub-space-margin-inline-end))", y = class y extends M(L) {
  constructor() {
    super(...arguments), this.beaconTagName = h, this.nextStub = null, this.attributeList = [], this.category = "", this.status = "", this.description = "", this.footnote = "", this.level = r.ONE, this.valuePropLeft = !1, this.withDropdown = !1, this.highlighted = !1, this.showDropdown = !1, this.hasCategory = !1, this.hasStatus = !1, this.hasDescription = !1, this.hasFootnote = !1, this.hasAttributeList = !1;
  }
  static get styles() {
    return [super.styles, G];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, q];
  }
  /**
   * renderAttributes
   *
   * @return {string} A string of attribute(s) that are seperated by INTERPUNCTS
   */
  renderAttributeList() {
    var e, n, i;
    if (!((e = this.attributeList) != null && e.length))
      return "";
    let t = "";
    for (let s = 0; s < ((n = this.attributeList) == null ? void 0 : n.length) - 1; s += 1)
      t += `${this.attributeList[s]} ${W} `;
    return t += this.attributeList[((i = this.attributeList) == null ? void 0 : i.length) - 1], t;
  }
  /**
   * Used when the current instance is a level 2 stub
   * Triggers the visibility of possible level 3 children
   * @param {boolean} show - Boolean parameter that shows children on true
   */
  triggerChildren(t) {
    var n, i, s, p;
    let e = this.next;
    if (t) {
      for (; e; )
        e == null || e.showRow(), e = e.next;
      (i = (n = this.parentTableRow) == null ? void 0 : n.querySelector(u)) == null || i.style.setProperty(m, v);
    } else {
      for (; e; )
        e == null || e.hideRow(), e = e.next;
      (p = (s = this.parentTableRow) == null ? void 0 : s.querySelector(u)) == null || p.style.setProperty(m, T);
    }
  }
  /**
   * Used to trigger the state of the dropdown and visibility of level 3 children in a level 2 stub instance
   */
  handleClick() {
    this.showDropdown = !this.showDropdown, this.triggerChildren(this.showDropdown);
  }
  /**
   * Use to receive a reference to the next table stub in multi-level context
   *
   * @return {BeaconTableStub} contains a level 2 or level 3 stub
   */
  get next() {
    return this.nextStub;
  }
  /**
   * sets the parentTableRow class variable
   * Searches up the DOM tree to look for the first instance of a table `<tr>` element
   */
  setParentTableRow() {
    const t = this.closest(Z);
    t && (this.parentTableRow = t);
  }
  /**
   * sets the nextStub class variable
   * Searches for the current stub sibling to maintain a linked-list between level 2 and level 3 stubs
   */
  setNextStub(t = null) {
    var n, i;
    if (t) {
      this.nextStub = t;
      return;
    }
    const e = (i = (n = this.parentTableRow) == null ? void 0 : n.nextElementSibling) == null ? void 0 : i.querySelector(h);
    this.level !== r.ONE && (this.level === r.TWO && (e == null ? void 0 : e.level) !== r.THREE || this.level === r.THREE && (e == null ? void 0 : e.level) !== r.THREE || (this.nextStub = e));
  }
  setParentTableRowAndSetNextStub() {
    this.setParentTableRow(), this.setNextStub();
  }
  /**
   * Hides parent table row by setting display to none
   */
  hideRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(R, X);
  }
  /**
   * Shows parent table row by setting display to default table-row
   */
  showRow() {
    var t;
    (t = this.parentTableRow) == null || t.style.setProperty(R, tt);
  }
  /**
   * Sets the hasMultiLevel property of parent beacon-table component to trigger vertical divider styles
   * in multi-level stub context
   */
  setMultiLevelTableProp() {
    const t = this.closest(U);
    t && t.triggerMultiLevel();
  }
  /**
   * addInsetRowBorders() removes the default full width borders of table header elements and instead adds
   * inset borders in multi-level stub context
   */
  addInsetRowBorders() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(u);
    t && (t.style.setProperty(m, v), t.style.setProperty(j, v), t.style.setProperty(Q, T), t.style.setProperty(J, Y));
  }
  /**
   * Clones passed in childEl and inserts it before the first child of parentEl
   * @param  {HTMLElement} parentEl: Element that will hold childEl
   * @param  {Array<HTMLElement>} childEl: Element to be cloned and prepended to parentEl
   * @returns void
   */
  cloneAndPrepend(t, e) {
    if (t && (e != null && e.length)) {
      const n = e.find((i) => i);
      if (n) {
        const i = n.cloneNode(!0);
        t.prepend(i);
      }
    }
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-render-action-zone - emits when the action zone is rendered inside a table
   */
  emitRenderActionZone(t) {
    x(this, z.RENDER_ACTION_ZONE, !!this.onBeaconRenderActionZone && this.onBeaconRenderActionZone());
  }
  /**
   * change action-zone-left slot padding if it contains a checkbox
   */
  handleActionZone() {
    if (this.actionZoneLeft && this.actionZoneLeft.length) {
      this.emitRenderActionZone();
      const t = this.actionZoneLeft.find((i) => i), e = (t == null ? void 0 : t.getAttribute("type")) === it || (t == null ? void 0 : t.tagName) === I, n = (t == null ? void 0 : t.querySelector(st)) || (t == null ? void 0 : t.querySelector(I));
      (e || n) && this.style.setProperty(nt, at);
    }
  }
  /**
   * Sets stub styles based on level and trailing nextStubs
   */
  setStubStyles() {
    var e;
    const t = (e = this.parentTableRow) == null ? void 0 : e.querySelector(u);
    t && (this == null ? void 0 : this.level) === r.TWO && this != null && this.showDropdown && (t == null || t.style.setProperty(m, v)), this.level === r.TWO && this.setLevelOneInsetBorder();
  }
  /**
   * Sets inset borders for sibling level 1 stub if current instance is a level 2 stub
   */
  setLevelOneInsetBorder() {
    var e, n, i, s, p, S;
    const t = (n = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : n.querySelector(h);
    t == null || t.addInsetRowBorders(), (s = (i = t == null ? void 0 : t.parentTableRow) == null ? void 0 : i.querySelector(u)) == null || s.style.setProperty(D, rt), (S = (p = t == null ? void 0 : t.parentTableRow) == null ? void 0 : p.querySelector(u)) == null || S.style.setProperty(N, lt);
  }
  /**
   * Styles set when current instance is a level 3 stub
   */
  levelThreeStubStyles() {
    var t, e, n, i, s;
    this.nextStub && ((t = this.nextStub) == null ? void 0 : t.level) === (this == null ? void 0 : this.level) && this.addInsetRowBorders(), (n = (e = this.parentTableRow) == null ? void 0 : e.querySelector(u)) == null || n.style.setProperty(D, et), (s = (i = this.parentTableRow) == null ? void 0 : i.querySelector(u)) == null || s.style.setProperty(N, ot);
  }
  /**
   * Sets the previous stub's next if a new row is inserted into the table
   */
  updatePreviousNext() {
    var e, n;
    const t = (n = (e = this.parentTableRow) == null ? void 0 : e.previousElementSibling) == null ? void 0 : n.querySelector(h);
    t && t.setNextStub();
  }
  tearDownTableStub() {
    var t, e;
    if (this.level === r.THREE) {
      const n = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(h);
      n && n.setNextStub(this.nextStub);
    }
  }
  render() {
    return c`
      <div class="wrapper">
        <div class="floating-stub">
          ${this.category ? c` <div class="category">
                <span class="category-icon"></span>
                <p class="category-text">${this.category}</p>
              </div>` : E}
          <div class="title"></div>
        </div>
        <div class="stub level-${this.level}">
          <div class="content-wrapper">
            <slot name="action-zone-left" @slotchange="${this.handleActionZone}"></slot>
            <div class="content has-cell-padding" part="content">
              <slot name="value-prop"></slot>
              <div class="standard">
                ${this.renderCategory()}
                <div class="title">
                  <slot></slot>
                  <slot class="title-text" name="title"></slot>
                  <slot class="title-footnote" name="title-footnote"></slot>
                  <slot name="title-icon"></slot>
                </div>
                ${this.renderAttributes()} ${this.renderStatus()} ${this.renderDescription()} ${this.renderFootnote()}
              </div>
            </div>
            <slot name="action-zone-right"></slot>
          </div>
          ${this.withDropdown ? c`${k`<${this.getScopedTag("beacon-button")}
          class="dropdown"
          @beacon-event-click="${this.handleClick}"
          variant=${O.TERTIARY}
          scale="${P.MINI}"
          label=${this.showDropdown ? "Hide Items" : "Show Items"}
          icon-align="right">${this.showDropdown ? c`<span slot="icon">${_($)}</span>` : c`<span slot="icon">${_(B)}</span>`}</${this.getScopedTag("beacon-button")}>`}` : E}
        </div>
      </div>
    `;
  }
  categorySlotChange(t) {
    var e;
    this.hasCategory = !!((e = this.slottedCategory) != null && e.length);
  }
  renderCategory() {
    const t = {
      category: !0,
      hide: !this.hasCategory && !this.category
    };
    return c` <div class=${g(t)}>
      <slot name="category-icon"></slot>
      <slot name="category" @slotchange=${this.categorySlotChange}><p class="category-text">${this.category}</p></slot>
    </div>`;
  }
  statusSlotChange(t) {
    var e;
    this.hasStatus = !!((e = this.slottedStatus) != null && e.length);
  }
  renderStatus() {
    const t = {
      status: !0,
      hide: !this.hasStatus && !this.status
    };
    return c` <div class=${g(t)}>
      <slot name="status" @slotchange=${this.statusSlotChange}>${this.status}</slot>
    </div>`;
  }
  descriptionSlotChange(t) {
    var e;
    this.hasDescription = !!((e = this.slottedDescription) != null && e.length);
  }
  renderDescription() {
    const t = {
      description: !0,
      hide: !this.hasDescription && !this.description
    };
    return c` <div class=${g(t)}>
      <slot name="description" @slotchange=${this.descriptionSlotChange}>${this.description}</slot>
    </div>`;
  }
  footnoteSlotChange(t) {
    var e;
    this.hasFootnote = !!((e = this.slottedFootnote) != null && e.length);
  }
  renderFootnote() {
    const t = {
      footnote: !0,
      hide: !this.hasFootnote && !this.footnote
    };
    return c` <div class=${g(t)}>
      <slot name="footnote" @slotchange=${this.footnoteSlotChange}>${this.footnote}</slot>
    </div>`;
  }
  attributesSlotChange(t) {
    var e;
    this.hasAttributeList = !!((e = this.slottedAttributes) != null && e.length);
  }
  renderAttributes() {
    var e;
    const t = {
      attributes: !0,
      hide: !this.hasAttributeList && !((e = this.attributeList) != null && e.length)
    };
    return c` <div class=${g(t)}>
      <slot name="attributes" @slotchange=${this.attributesSlotChange}>${this.renderAttributeList()}</slot>
    </div>`;
  }
  postrenderTableStubSetup() {
    this.cloneAndPrepend(this.floatingTitle, this.titleText), this.cloneAndPrepend(this.floatingCategory, this.categoryIcon), (this == null ? void 0 : this.level) !== r.ONE && Promise.resolve(this.setNextStub()).then(() => {
      (this == null ? void 0 : this.level) === r.TWO && this.showDropdown && this.triggerChildren(this.showDropdown);
    }), this.level === r.TWO && this.setMultiLevelTableProp(), this.level === r.THREE && (this.levelThreeStubStyles(), this.updatePreviousNext(), this.hideRow());
  }
};
y.tagName = h, y.nestedComponents = K;
let o = y;
a([
  l({ attribute: "attribute-list", type: Array, reflect: !0, alternateSlot: "attributes", sync: !1 })
], o.prototype, "attributeList", 2);
a([
  l({ reflect: !0, alternateSlot: "category", sync: !1 })
], o.prototype, "category", 2);
a([
  l({ reflect: !0, alternateSlot: "status", sync: !1 })
], o.prototype, "status", 2);
a([
  l({ reflect: !0, alternateSlot: "description", sync: !1 })
], o.prototype, "description", 2);
a([
  l({ reflect: !0, alternateSlot: "footnote", sync: !1 })
], o.prototype, "footnote", 2);
a([
  l({ reflect: !0 })
], o.prototype, "level", 2);
a([
  l({ attribute: "value-prop-left", type: Boolean, reflect: !0 })
], o.prototype, "valuePropLeft", 2);
a([
  l({ attribute: "with-dropdown", type: Boolean, reflect: !0 })
], o.prototype, "withDropdown", 2);
a([
  l({ type: Boolean, reflect: !0 })
], o.prototype, "highlighted", 2);
a([
  l({ attribute: "show-dropdown", type: Boolean, reflect: !0 })
], o.prototype, "showDropdown", 2);
a([
  l({ attribute: "sort-value", reflect: !0 })
], o.prototype, "sortValue", 2);
a([
  l({ type: Function })
], o.prototype, "onBeaconRenderActionZone", 2);
a([
  b({ slot: "title-footnote" })
], o.prototype, "titleFootnote", 2);
a([
  b({ slot: "title-icon" })
], o.prototype, "titleIcon", 2);
a([
  b({ slot: "action-zone-left" })
], o.prototype, "actionZoneLeft", 2);
a([
  b({ slot: "category-icon" })
], o.prototype, "categoryIcon", 2);
a([
  b({ slot: "title" })
], o.prototype, "titleText", 2);
a([
  w(".title-text")
], o.prototype, "titleElement", 2);
a([
  w(".floating-stub .category .category-icon")
], o.prototype, "floatingCategory", 2);
a([
  w(".floating-stub .title")
], o.prototype, "floatingTitle", 2);
a([
  f()
], o.prototype, "hasCategory", 2);
a([
  b({ flatten: !0, slot: "category" })
], o.prototype, "slottedCategory", 2);
a([
  f()
], o.prototype, "hasStatus", 2);
a([
  b({ flatten: !0, slot: "status" })
], o.prototype, "slottedStatus", 2);
a([
  f()
], o.prototype, "hasDescription", 2);
a([
  b({ flatten: !0, slot: "description" })
], o.prototype, "slottedDescription", 2);
a([
  f()
], o.prototype, "hasFootnote", 2);
a([
  b({ flatten: !0, slot: "footnote" })
], o.prototype, "slottedFootnote", 2);
a([
  f()
], o.prototype, "hasAttributeList", 2);
a([
  b({ flatten: !0, slot: "attributes" })
], o.prototype, "slottedAttributes", 2);
a([
  C
], o.prototype, "setParentTableRowAndSetNextStub", 1);
a([
  V
], o.prototype, "tearDownTableStub", 1);
a([
  C
], o.prototype, "postrenderTableStubSetup", 1);
export {
  o as B,
  r as L
};
